export default [{
    path: '/frailtyCalc',
    component: () => import('../../views/frailtyCalc'),
    children: []
}]